import { twoLinkPage } from './twoLinkPage'
import { oneLinkPage } from './oneLinkPage'

export default {
  twoLinkPage, // 两联
  oneLinkPage, // 一联
}
